import React from 'react'
import { animations } from '../../helper/variables'
import VisibilityWrapper from '../../helper/visibilityWrapper'
import Sparks from '../graphic/sparks'
import SplitText from 'react-pose-text'
import './introBlock.css'
import Parallax from '../../helper/parallax'

const IntroBlock = props => {
  const { data, momentumScrollValue } = props

  const slideAnimation = animations('SLIDE')

  return (
    <VisibilityWrapper partialVisibility={true}>
      {({ isVisible }) => {
        return (
          <div className="about-intro">
            <Parallax
              viewportScroll={momentumScrollValue}
              moveRange="200"
              disabledOnMobile
            >
              <Sparks type="1" className="spark3" />
            </Parallax>
            <div>
              <h2 className={`type-h11 color-white ribbon`}>
                <SplitText
                  initialPose="exit"
                  withParent={false}
                  pose={isVisible ? 'enter' : 'exit'}
                  charPoses={slideAnimation}
                >
                  {data.introRibbonText}
                </SplitText>
              </h2>
              <div className={`intro-context type-h1 color-white main`}>
                {data.introText}
              </div>
            </div>
          </div>
        )
      }}
    </VisibilityWrapper>
  )
}

export default IntroBlock
